import { Badge, getBadgeSize } from '@/components/badge/badge.component';
import { Loading } from '@/components/loading';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';
import { useFieldNutrientData } from '@/modules/Report/Report.api';

type FieldNutrientInfoTableProps = {
  farmId: string;
  fieldId: string;
};

export const FieldNutrientInfoTable = ({ farmId, fieldId }: FieldNutrientInfoTableProps) => {
  const { data: fieldNutrients, status } = useFieldNutrientData(farmId, fieldId);
  if (status === 'pending') {
    return <Loading />;
  }
  if (status === 'error' || !fieldNutrients) {
    return <>Error</>;
  }

  return (
    <div className={cn('flex flex-col mb-10')}>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Analysis</TableHead>
            <TableHead className="text-center">Result</TableHead>
            <TableHead>Comments</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody className={cn('border-t-2')}>
          {fieldNutrients &&
            fieldNutrients.map((field, index) => {
              const formattedValue = field.result.value;
              const badgeSize = formattedValue ? getBadgeSize(formattedValue.length) : 'm';
              return (
                <TableRow key={index}>
                  <TableCell className="text-left">{field.metric}</TableCell>
                  <TableCell className="text-center">
                    <span className="inline-block">
                      <Badge value={formattedValue} color={field.result.color} size={badgeSize} textAlign="center" />
                    </span>
                  </TableCell>
                  <TableCell className="text-left">{field.comment}</TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </div>
  );
};

FieldNutrientInfoTable.displayName = 'FieldNutrientInfoTable';
